import * as Constants from "../constants";

const LOG_API_URL = Constants.API_URL + 'v2/preview/log';
const MAX_ERROR_EVENTS = 10;

let previewCode = null;
let errorEventCount = 0;
let globalHandlersInstalled = false;

function browserInfo() {
    return {
        user_agent: navigator.userAgent,
        language: navigator.language,
        platform: navigator.platform,
        touch_points: navigator.maxTouchPoints,
        screen: `${window.screen.width}x${window.screen.height}@${window.devicePixelRatio || 1}`,
        viewport: `${window.innerWidth}x${window.innerHeight}`,
        memory_gb: navigator.deviceMemory || null,
        cores: navigator.hardwareConcurrency || null,
        connection: navigator.connection ? navigator.connection.effectiveType : null,
        online: navigator.onLine
    };
}

function send(payload) {
    const body = JSON.stringify(payload);

    try {
        // keepalive lets the request finish even when the page is being unloaded.
        return fetch(LOG_API_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body,
            keepalive: true
        }).catch(() => {});
    } catch(error) {
        return Promise.resolve();
    }
}

/**
 * Writes debugging events into the preview's upload.log on the server. Every
 * call is best effort: the uploader must never break because logging fails.
 */
const UploadLogService = {
    setPreview(code) {
        previewCode = code || null;
    },

    log(event, data = {}) {
        if(!previewCode) {
            return Promise.resolve();
        }

        return send({
            code: previewCode,
            event: String(event).slice(0, 64),
            data: { ...data, client_time: new Date().toISOString() }
        });
    },

    logSessionStart(extra = {}) {
        return this.log('session_start', { ...browserInfo(), ...extra });
    },

    logError(kind, error, extra = {}) {
        if(errorEventCount >= MAX_ERROR_EVENTS) {
            return Promise.resolve();
        }
        errorEventCount++;

        return this.log('js_error', {
            kind,
            message: error && error.message ? error.message : String(error),
            stack: error && error.stack ? String(error.stack).slice(0, 1500) : null,
            ...extra
        });
    },

    installGlobalHandlers() {
        if(globalHandlersInstalled) {
            return;
        }
        globalHandlersInstalled = true;

        window.addEventListener('error', event => {
            this.logError('error', event.error || event.message, {
                source: event.filename ? `${event.filename}:${event.lineno}:${event.colno}` : null
            });
        });
        window.addEventListener('unhandledrejection', event => {
            this.logError('unhandledrejection', event.reason);
        });
    }
};

export default UploadLogService;
